import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var bodyStyle = 'dialog_bodyStyle__1kkjbsh7';
var contentInnerStyle = 'dialog_contentInnerStyle__1kkjbsh6';
var contentPositionerStyle = 'dialog_contentPositionerStyle__1kkjbsh2';
var contentStyle = 'dialog_contentStyle__1kkjbsh5';
var descriptionStyle = 'dialog_descriptionStyle__1kkjbsh9';
var fogStyle = 'dialog_fogStyle__1kkjbsh1';
var footerStyle = createRuntimeFn({defaultClassName:'dialog_footerStyle__1kkjbsha',variantClassNames:{orientation:{vertical:'dialog_footerStyle_orientation_vertical__1kkjbshb',horizontal:'dialog_footerStyle_orientation_horizontal__1kkjbshc'}},defaultVariants:{},compoundVariants:[]});
var portalContainerStyle = 'dialog_portalContainerStyle__1kkjbshd';
var scrollAreaViewportStyle = 'dialog_scrollAreaViewportStyle__1kkjbsh0';
var titleStyle = 'dialog_titleStyle__1kkjbsh8';

export { bodyStyle, contentInnerStyle, contentPositionerStyle, contentStyle, descriptionStyle, fogStyle, footerStyle, portalContainerStyle, scrollAreaViewportStyle, titleStyle };
//# sourceMappingURL=dialog.vanilla.mjs.map
